import { createFileRoute } from '@tanstack/react-router'

import Footer from '@/components/landing/footer'
import Navbar from '@/components/landing/navbar'
import WhatsAppFloatingButton from '@/components/ui/whatsapp-floating'

import AvailablePositionsSection from './-components/available-possition-section'
import CareerHeroSection from './-components/hero'
import OfficeAtmosphereSection from './-components/office-section'
import WhyChooseYesSection from './-components/why-yes'

export const Route = createFileRoute('/career-page/')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      {/* Hero Section */}
      <CareerHeroSection />

      {/* Why Choose YES Section */}
      <WhyChooseYesSection />

      {/* Office Atmosphere Section */}
      <OfficeAtmosphereSection />

      {/* Available Positions Section */}
      <AvailablePositionsSection />

      {/* WhatsApp Floating Button */}
      <WhatsAppFloatingButton />

      {/* Footer */}
      <Footer />
    </div>
  )
}
